/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { BrevityTimeline } from '@tencent/brevity';
import { ITimeline } from './interface';

export default class CustomTimeline implements ITimeline {
    public static globalTimeline = BrevityTimeline.globalTimeline;
    public instance;

    public constructor(params?: any) {
        this.instance = new BrevityTimeline(params);
    }
    /**
     * 添加子时间轴/动画
     */
    public add(timelineOrAnim, position?: any): void {
        const ins = timelineOrAnim?.instance;
        if (timelineOrAnim?.instance) {
            this.instance.add(ins, position);
        }
    }
    /**
     * 添加时间轴标签
     */
    public addLabel(str): void {
        this.instance.addLabel(str);
    }
    /**
     * 获取时间轴实例的children，children可能为子时间轴实例，也可能为动画实例
     * @returns Array 如：[Timeline]/[Animation]/[Timeline, Animation]
     */

    public getChildren() {
        return this.instance.getChildren();
    }
    /**
     * 判断时间轴所管控的动画是否还在运行，只要有一个动画在运行，即返回true
     * @returns boolean
     */

    public isActive(): boolean {
        return this.instance.isActive();
    }

    /**
     * 暂停该时间轴所管控的所有动画
     */
    public pause(): void {
        this.instance.pause();
    }
    /**
     * 从动画的起始位置，重新播放该时间轴所管控的所有动画
     */
    public restart(): void {
        this.instance.restart();
    }

    /**
     * 播放该时间轴所管控的所有动画
     */
    public play(): void {
        this.instance.play();
    }
    /**
     * 通过id获取该时间轴管控的某个具体的子时间轴实例或者动画实例
     * @param animationId
     * @returns
     */
    public getById(timelineOrAnimId: string) {
        return this.instance.getById(timelineOrAnimId);
    }

    /**
     * 播放起止位置之间的动画
     * @param fromPos 起始位置
     * @param toPos 终止位置
     * @param options
     * @returns
     */
    public tweenFromTo(fromPos, toPos, options) {
        return this.instance.tweenFromTo(fromPos, toPos, options);
    }

    /**
     * 清空该timeline下的所有子timeline以及所有子动画
     */
    public clear() {
        this.instance.clear();
    }

    public getDuration() {
        return this.instance._dur;
    }
}
